export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["unseen"] = "unseen";
    NotificationStatus["dismissed"] = "dismissed";
})(NotificationStatus || (NotificationStatus = {}));
export var NotificationCountType;
(function (NotificationCountType) {
    NotificationCountType["site"] = "site";
    NotificationCountType["sensor"] = "sensor";
    NotificationCountType["equipment"] = "equipment";
    NotificationCountType["space"] = "space";
    NotificationCountType["gateway"] = "gateway";
    NotificationCountType["all"] = "all";
})(NotificationCountType || (NotificationCountType = {}));
export var SensorParamType;
(function (SensorParamType) {
    SensorParamType["UNKNOWN"] = "UNKNOWN";
    SensorParamType["TEMPERATURE"] = "TEMPERATURE";
    SensorParamType["HUMIDITY"] = "HUMIDITY";
    SensorParamType["BINARY"] = "BINARY";
    SensorParamType["SENSOR_STATUS"] = "SENSOR_STATUS";
    SensorParamType["SENSOR_ONLINE_STATUS"] = "SENSOR_ONLINE_STATUS";
    SensorParamType["GATEWAY_ONLINE_STATUS"] = "GATEWAY_ONLINE_STATUS";
    SensorParamType["ENERGYPRO_ONLINE_STATUS"] = "ENERGYPRO_ONLINE_STATUS";
    SensorParamType["WEATHER"] = "WEATHER";
    SensorParamType["OPEN_COUNTER"] = "OPEN_COUNTER";
    SensorParamType["ACTIVE_POWER"] = "ACTIVE_POWER";
    SensorParamType["GATEWAY_STATUS"] = "GATEWAY_STATUS";
    SensorParamType["VENSTAR_SENSOR_STATUS"] = "VENSTAR_SENSOR_STATUS";
})(SensorParamType || (SensorParamType = {}));
export var NotificationPriority;
(function (NotificationPriority) {
    NotificationPriority["normal"] = "normal";
    NotificationPriority["low"] = "low";
    NotificationPriority["medium"] = "medium";
    NotificationPriority["high"] = "high";
    NotificationPriority["highest"] = "highest";
    NotificationPriority["critical"] = "critical";
})(NotificationPriority || (NotificationPriority = {}));
